import { render, staticRenderFns } from "./TransactionHistoryTable.vue?vue&type=template&id=144cc00d&scoped=true&"
import script from "./TransactionHistoryTable.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistoryTable.vue?vue&type=style&index=0&id=144cc00d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144cc00d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
